import React from 'react';

/**
 * CatalogueToolbar — shared search + filter + settings toolbar
 * used across Services, Products, and other catalogue tabs.
 */
const CatalogueToolbar = ({
    searchValue,
    onSearchChange,
    onSearchPaste,
    onSearchClear,
    showClear,
    placeholder = 'Search...',
    onFilterClick,
    onSettingsClick,
}) => (
    <div className="svc-toolbar">
        <div className="pos-search-wrap">
            <svg className="pos-search-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8e8e93" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input
                className="pos-search-input"
                type="text"
                value={searchValue}
                onChange={onSearchChange}
                onPaste={onSearchPaste}
                placeholder={placeholder}
            />
            {showClear && (
                <button className="pos-search-clear" onClick={onSearchClear}>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="#8e8e93" strokeWidth="1.6" strokeLinecap="round">
                        <line x1="3" y1="3" x2="11" y2="11" /><line x1="11" y1="3" x2="3" y2="11" />
                    </svg>
                </button>
            )}
        </div>
        <div className="svc-toolbar-actions">
            {onFilterClick && (
                <button type="button" className="beu-btn-ghost" onClick={onFilterClick}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
                    </svg>
                    <span>Filters</span>
                </button>
            )}
            {onSettingsClick && (
                <button type="button" className="beu-icon-btn" onClick={onSettingsClick} aria-label="Settings">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="3" />
                        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68 1.65 1.65 0 0 0 10 3.17V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
                    </svg>
                </button>
            )}
        </div>
    </div>
);

export default CatalogueToolbar;
